import {i18n} from 'common.js'
import {useNavigate} from 'react-router-dom'
import {useGetAllMediaRequestsQuery} from 'store/Store.js'

const useAllMediaRequests = () => {
    const {data: mediaRequests} = useGetAllMediaRequestsQuery()
    const navigate = useNavigate()

    const t18AllMediaRequests = (text) => i18n.t(`allMediaRequests.${text}`)

    const rows = mediaRequests
        ? mediaRequests.map(({choreographer, mediaCount}) => ({
              name: choreographer.fullName,
              mediaRequests: mediaCount,
              _id: choreographer._id,
          }))
        : []

    const columns = [
        {id: 'name', label: t18AllMediaRequests('name')},
        {id: 'mediaRequests', label: t18AllMediaRequests('mediaRequests')},
    ]

    const handleRowClick = ({_id}) => {
        navigate(`/myRequests/${_id}`)
    }
    return {t18AllMediaRequests, mediaRequests, rows, columns, handleRowClick}
}

export default useAllMediaRequests
